import {useRef, useEffect} from 'react';

export function useIdleTimeout(onIdle)
{
    const timeoutRef = useRef(null);
    const idleTime = 15 * 60 * 1000;

    const resetTimeout = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => { 
            onIdle();
        }, idleTime);
    };

    useEffect(() => {
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'click'];
        
        events.forEach(event => {
            window.addEventListener(event, resetTimeout, true);
        });
        
        resetTimeout();
        
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            events.forEach(event => {
                window.removeEventListener(event, resetTimeout, true);
            });
        };
    }, [idleTime, onIdle]);
}